<template>
    <section>
        <div v-if="tabs.length > 1" class="container mb-8">
            <nav class="flex items-center">
                <camera-icon class="block w-6 h-auto mr-4" />

                <tabs v-model="mode" :tabs="tabs" />
            </nav>
        </div>

        <slot :mode="mode" :set-mode="setMode" :on-before-leave="onBeforeLeave" :on-after-leave="onAfterLeave" />
    </section>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import Tabs from './Tabs.vue';
    import CameraIcon from '@/img/icons/camera.svg?component';

    const props = defineProps({
        hasCompleteImages: {
            type: Boolean,
            default: false,
        },
        hasConstructImages: {
            type: Boolean,
            default: false,
        },
    });

    const mode = ref(props.hasCompleteImages ? 'complete' : 'construct');

    const tabs = computed(() => {
        const tabs = [];

        if (props.hasCompleteImages) {
            tabs.push({
                key: 'complete',
                label: 'Complete',
            });
        }

        if (props.hasConstructImages) {
            tabs.push({
                key: 'construct',
                label: 'Construct',
            });
        }

        return tabs;
    });

    const setMode = newMode => {
        mode.value = newMode;
    };

    const onBeforeLeave = element => {
        const width = element.offsetWidth;
        const height = element.offsetHeight;

        element.style.width = `${width}px`;
        element.style.height = `${height}px`;
    };

    const onAfterLeave = element => {
        element.style.removeProperty('width');
        element.style.removeProperty('height');
    };
</script>
